
import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import axios from "../../utils/axiosInstance";
import { withNavigation } from "../../utils/withNavigation";

import "swiper/css";
import "swiper/css/navigation";
import "./PostSlider.css";

class PostSlider_Recently_Viewed extends Component {

  constructor(props) {
    super(props);

    this.state = {
      posts: [],
      isLoading: true,
      error: null,
      slideIndexes: {},
    };
  }

  async componentDidMount() {
    try {
      const viewed =
        JSON.parse(localStorage.getItem("recently_viewed_products")) || [];

      if (viewed.length === 0) {
        this.setState({
          posts: [],
          isLoading: false,
        });
        return;
      }

      const ids = viewed.join(",");

      const res = await axios.get(`/get_recently_viewed?ids=${ids}`);

      this.setState({
        posts: res.data?.data || [],
        isLoading: false,
      });

    } catch (error) {
      console.error(error);
      this.setState({
        error: "Failed to load posts",
        isLoading: false,
      });
    }
  }

  handleSlideChange = (postId, swiper) => {
    this.setState((prevState) => ({
      slideIndexes: {
        ...prevState.slideIndexes,
        [postId]: swiper.activeIndex + 1,
      },
    }));
  };

  limitChars = (text, limit = 20) => {
    if (!text) return "";

    return text.length > limit
      ? text.substring(0, limit) + "..."
      : text;
  };

  render() {

    const { title, sliderId } = this.props;
    const { posts, isLoading, error, slideIndexes } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api","");
    const uploadUrl = `${baseUrl}/uploads/posts/`;

    if (isLoading) {
      return (
        <div className="container section">
          <p>Loading {title}...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="container section">
          <p className="text-danger">{error}</p>
        </div>
      );
    }

    return (
      <div className="container section">
        <h3 className="mb-5">{title}</h3>

        <div className="hotel-carousel-wrapper">
          <Swiper
            modules={[Navigation]}
            navigation={{
              nextEl: `.next-${sliderId}`,
              prevEl: `.prev-${sliderId}`,
            }}
            spaceBetween={15}
            slidesPerView={5}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
              1200: { slidesPerView: 5 },
            }}
          >
            {posts.map((post) => {
              let gallery = [];

              try {
                gallery = post.gallery_images
                  ? JSON.parse(post.gallery_images)
                  : [];
              } catch {
                gallery = [];
              }

              const allImages = post.feature_image
                ? [post.feature_image, ...gallery]
                : gallery.length > 0
                ? gallery
                : ["default.jpg"];

              return (
                <SwiperSlide key={post.id}>
                  <div className="hotel-card">
                    <div className="hotel-img">
                      <Swiper
                        modules={[Navigation]}
                        navigation
                        slidesPerView={1}
                        className="hotel-image-slider"
                        onSlideChange={(swiper) =>
                          this.handleSlideChange(
                            post.id,
                            swiper
                          )
                        }
                      >
                        {allImages.map((img, i) => (
                          <SwiperSlide key={i}>
                            <img
                              src={`${uploadUrl}${img}`}
                              alt={post.title}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      <div className="image-count">
                        {slideIndexes[post.id] || 1}/
                        {allImages.length}
                      </div>

                      <div className="price-box">
                        <span>
                          ৳{post.sales_price} / Day
                        </span>
                        <span>
                          <i className="fa fa-star text-warning"></i>
                          5.0
                        </span>
                      </div>
                    </div>

                    <div
                      className="hotel-info"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.props.navigate(
                          `/listing/${post.id}`
                        )
                      }>
                      <p className="mb-1">
                        <i className="fa fa-map-marker-alt"></i>{" "}
                        {post.category_name || "Location"}
                      </p>
                      <h5>{this.limitChars( post.title, 40 )}</h5>
                      <div className="features">
                        <span title="Adults">
                          <i className="fa fa-users"></i>
                          {post.adults}
                        </span>

                        <span title="Beds">
                          <i className="fa fa-bed"></i>
                          {post.beds}
                        </span>

                        <span title="Baths">
                          <i className="fa fa-shower"></i>
                          {post.baths}
                        </span>

                        <span title="Size">
                          <i className="fa fa-square"></i>
                          {post.size} sqft
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div
            className={`swiper-button-prev-main prev-${sliderId}`}>
            <i className="fa fa-chevron-left"></i>
          </div>
          <div
            className={`swiper-button-next-main next-${sliderId}`}>
            <i className="fa fa-chevron-right"></i>
          </div>
        </div>
      </div>
    );
  }
}

export default withNavigation(PostSlider_Recently_Viewed);


